import api from '../../../App/socket';

export const changeUserPassword = (_id, password) => (
    api.send({
        api: 'module',
        module: 'UserManagement',
        classMethod: 'ChangePassword',
        options: {
            where: { _id },
            update: { password },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/requests/change_user_password_request.js